/**
 * Created by dikla on 15/9/16.
 */

(function () {
    'use strict';

    // @ngInject
    function NetworkOnboardingIntroductionControllerCtor($modalInstance, $scope, UsersManager,NetworkManager,NetworkOnboardingService, AnalyticsService, $state, AppStates) {
        this.$modalInstance = $modalInstance;
        this.NetworkManager = NetworkManager;
        this.NetworkOnboardingService = NetworkOnboardingService;
        this.AnalyticsService = AnalyticsService;
        this.AppStates = AppStates;
        this.$state = $state;

        this.__objectType = 'NetworkOnboardingIntroductionController';
        AnalyticsService.trackPageView(this, AnalyticsService.analytics_events.network_onboarding_introduction_load);
        this.user = UsersManager.getCurrUser();

        // first time to community from workflow
        // vs. old user being introduced to opps
        this.isFirstIntro = true;

    }

    Controllers.NetworkOnboardingIntroductionController = Class(Controllers.BaseController, {
        constructor: NetworkOnboardingIntroductionControllerCtor,

        closeAndTakeMeToQuickSetup: function closeAndTakeMeToQuickSetup() {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_onboarding_introduction_submit);
            this.$state.go(this.AppStates.root_network_edit_profile);
            this.$modalInstance.close();
        },

        close : function close() {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_onboarding_introduction_close);
            this.$modalInstance.close();
        }

    });
}());